import $ from 'jquery';
import $Scroll from '../../common/smooth-scrolling';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  workPageContent: '.work-page-content',
  repairCategories: '.v2-repair-categories',
  repairCategoryItem: '.v2-repair-categories li',
  subrepairCategories: '.v2-subrepair-categories',
  repairItem: '.repair-item',
  moreInfoModal: '#work-item-more-info-modal',
  repairCategory: '.js-repair-category',
  browseByCategory: '.browse-by-category',
  repairCategoryTree: '.repair-category-tree',
  chooseRepair: '.js-choose-repair',
  serviceFlowSection: '.v2-service-flow-section',
  toggleChecklist: '.js-toggle-checklist',
  checklist: '.js-checklist',
  tabsNavigation: '.v2-tabs-navigation li',
  tabs: '.v2-tabs',
  tabsContent: '.v2-tabs-content',
};

const EVENTS = {
  itemAddedRemoved: 'item_added item_removed',
  activate: 'activate',
};

const CSS_CLASSES = {
  active: 'active',
  hidden: 'hidden',
  isOpen: 'is-open',
  show: 'show',
};

const ANIMATION = {
  duration: 'fast',           // jQuery animation speed
  scrollOffset: 30,           // pixels to offset scroll position
  scrollOffsetDesktop: 160,   // pixels to offset scroll position on desktop
};

export default class RepairCategoryUI {
  init() {
    this._bindRepairAccordion();
    this._bindRepairItemClick();
    this._bindModalItemEvents();
    this._bindCategoryActivation();
    this._subscribeToRepairCategoryEvents();
    this._bindBrowseByCategory();
    this._bindChooseRepair();
    this._bindModalChecklist();
    this._bindTabs();
  }

  _bindRepairAccordion() {
    $(SELECTORS.workPageContent).on('click', SELECTORS.repairCategoryItem, function (e) {
      if (e.isDefaultPrevented()) return;
      $(this).toggleClass(CSS_CLASSES.active);
      $(this).children(SELECTORS.subrepairCategories).slideToggle();
    });
  }

  _bindRepairItemClick() {
    $(SELECTORS.workPageContent).on('click', SELECTORS.repairItem, function (e) {
      e.preventDefault();
    });
  }

  _bindModalItemEvents() {
    $(SELECTORS.moreInfoModal).on(EVENTS.itemAddedRemoved, function () {
      var open_modal = $(this);
      if (open_modal.length && open_modal.hasClass(CSS_CLASSES.show)) {
        return window.Application.close_modal(open_modal);
      }
    });
  }

  _bindCategoryActivation() {
    $(SELECTORS.repairCategory).on(EVENTS.activate, function () {
      var $this = $(this);

      $this.addClass(CSS_CLASSES.active);
      var target = $this;
      const section = History.getState().data.section;
      if (section) {
        target = $this.find(`[data-repair-category="${section}"]`);
        target = target.length > 0 ? target : $this;
      }
      const subCategories = $this.children(SELECTORS.subrepairCategories);
      subCategories.slideDown(function () {
        if (subCategories.last().is(this)) {
          if ($(SELECTORS.repairCategories).css('max-height') !== 'none') {
            $(SELECTORS.repairCategories).scrollTop(target.parents('ul').position().top - ANIMATION.scrollOffset);
          } else {
            $(window).scrollTop(target.offset().top - ANIMATION.scrollOffsetDesktop);
          }
        }
      });
    });
  }

  _subscribeToRepairCategoryEvents() {
    EventBus.on('repair-category:activate', (data) => {
      this._activateCategory(data.element);
    });
  }

  _activateCategory(element) {
    var $this = $(element);

    $this.addClass(CSS_CLASSES.active);
    var target = $this;
    const section = History.getState().data.section;
    if (section) {
      target = $this.find(`[data-repair-category="${section}"]`);
      target = target.length > 0 ? target : $this;
    }
    const subCategories = $this.children(SELECTORS.subrepairCategories);
    subCategories.slideDown(function () {
      if (subCategories.last().is(this)) {
        if ($(SELECTORS.repairCategories).css('max-height') !== 'none') {
          $(SELECTORS.repairCategories).scrollTop(target.parents('ul').position().top - ANIMATION.scrollOffset);
        } else {
          $(window).scrollTop(target.offset().top - ANIMATION.scrollOffsetDesktop);
        }
      }
    });
  }

  _bindBrowseByCategory() {
    $(SELECTORS.browseByCategory).on('click', (event) => {
      $(event.currentTarget).toggleClass(CSS_CLASSES.active);
      var categoryTree = $(SELECTORS.repairCategoryTree);
      if (categoryTree.hasClass(CSS_CLASSES.hidden)) {
        categoryTree.removeClass(CSS_CLASSES.hidden);
        $(SELECTORS.repairCategoryTree).slideDown(ANIMATION.duration, function () {
          $Scroll.smoothScroll($(event.currentTarget));
        });
      } else {
        $(SELECTORS.repairCategoryTree).slideUp(ANIMATION.duration, function () {
          categoryTree.addClass(CSS_CLASSES.hidden);
        });
      }
    });
  }

  _bindChooseRepair() {
    $(SELECTORS.chooseRepair).on('click', function () {
      $(this).parents(SELECTORS.serviceFlowSection).addClass(CSS_CLASSES.hidden).next(SELECTORS.serviceFlowSection).removeClass(CSS_CLASSES.hidden);
    });
  }

  _bindModalChecklist() {
    $(SELECTORS.moreInfoModal).on('click', SELECTORS.toggleChecklist, function () {
      $(this).next(SELECTORS.checklist).toggleClass(CSS_CLASSES.hidden);
    });
  }

  _bindTabs() {
    $(SELECTORS.tabsNavigation).on('click', function (e) {
      e.preventDefault();
      var target = $(this).data('target');
      $(this).siblings().removeClass(CSS_CLASSES.active);
      $(this).addClass(CSS_CLASSES.active);
      $(this).parents(SELECTORS.tabs).children(SELECTORS.tabsContent).removeClass(CSS_CLASSES.isOpen);
      $(this)
        .parents(SELECTORS.tabs)
        .find(`${SELECTORS.tabsContent}[data-tab="${target}"]`)
        .addClass(CSS_CLASSES.isOpen);
    });
  }
}
